<template>
    <span class="badge-year border rounded-3 m-1">{{ year }} 年度</span>
</template>

<script>
export default {
    name: 'BadgeYear',
    props: {
        year: {
            type: Number,
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge-year {padding: .5rem 1rem; border-color: #acacac !important; white-space: nowrap; line-height: 2.5rem;}
</style>
